import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { AddCrowdsaleComponent } from "./add-crowdsale.component";
import { AddCrowdsaleLayoutComponent } from "./add-crowdsale.layout";
import { ThemeModule } from "../@theme/theme.module";
import {
    NbButtonModule,
    NbCardModule,
    NbDialogModule,
    NbInputModule,
} from "@nebular/theme";
import { AddCrowdsaleRoutingModule } from "./add-crowdsale.routing.module";
import { FormsModule } from "@angular/forms";

@NgModule({
    declarations: [AddCrowdsaleComponent, AddCrowdsaleLayoutComponent],
    imports: [
        CommonModule,
        FormsModule,
        AddCrowdsaleRoutingModule,
        ThemeModule,
        NbCardModule,
        NbButtonModule,
        NbInputModule,
        NbDialogModule,
    ],
})
export class AddCrowdsaleModule {}
